module.exports = __webpack_public_path__ + "img/Wolt_640x200.b5d89961.jpg";